import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateConfigurePayload } from 'api/actions/revision-template-configure/revision-template-configure-payload';
import { RevisionTemplateConfigurePathParameters } from 'api/actions/revision-template-configure/revision-template-configure-path-parameters';
import { RevisionTemplateConfigureResponse } from 'api/actions/revision-template-configure/revision-template-configure-response';

type RevisionTemplateConfigureQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateConfigure action.
 */
export const revisionTemplateConfigureActionPath = new SweetPath<keyof RevisionTemplateConfigurePathParameters>(
  '/api/revision-template/configure/{revisionTemplateId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionTemplateConfigure actions.
 */
export default function createRevisionTemplateConfigureAction(axios: AxiosInstance) {
  return function revisionTemplateConfigureAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateConfigurePathParameters;
    query?: RevisionTemplateConfigureQueryParameters;
    payload: RevisionTemplateConfigurePayload;
  }) {
    const path = revisionTemplateConfigureActionPath.insert(parameters);

    return axios.request<RevisionTemplateConfigureResponse, RevisionTemplateConfigureResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
